import { TSortType } from '../../types/filters';
import { IApplicationState } from '../../types/redux';

export function selectSortType(state: IApplicationState): TSortType {
  const { filters } = state;

  return filters.sort ?? 'default';
}
